module.exports = __webpack_public_path__ + "static/img/home29.22abfd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/home29.png
// module id = Ij60
// module chunks = 4